import React, { useState } from 'react';
import { categories } from '../data/offers';
import CategorySelector from '../components/CategorySelector';
import OffersSwiper from '../components/OffersSwiper';

export default function WhatWeOffer() {
  // initial active category
  const [activeId, setActiveId] = useState(categories[0].id);

  return (
    <>
      <section id="moving-section" className="popular-moves section no-vertical-padding container">
        <h2 className="title has-text-centered">Flourish with us</h2>

        {/* Category buttons */}
        <CategorySelector activeId={activeId} onSelect={setActiveId} />

        {/* Swiper, shows/hides slide content based on activeId */}
        <OffersSwiper activeId={activeId} />

        {/* “Dive deeper” link */}
        <div className="has-text-centered">
          <a href="/" className="button grey is-shadowless is-rounded">
            <span>Dive deeper</span>
          </a>
        </div>
      </section>

      {/* “Get Started Today” section */}
      <section className="get-started-upspacing community-stats section no-vertical-padding">
        <h2 className="title has-text-centered">Get Started Today</h2>
        <div className="container">
          <div className="columns is-multiline is-mobile is-variable is-2-mobile is-4-tablet community-container has-text-centered">
            <div className="column is-12-mobile is-4-tablet spacing-between">
              <div className="community-stats-item greyout">
              <div className="actionwords">
              <span>Consult</span>
                </div>
                <div className="community-title greyout-phrase">
                Brand Review
                </div>
              </div>
            </div>

            <div className="column is-12-mobile is-4-tablet spacing-between">
              <div className="community-stats-item greyout">
              <div className="actionwords">
                  <span>Demo</span>
                </div>
                <div className="community-title greyout-phrase">
                How It Works
                </div>
              </div>
            </div>

            <div className="column is-12-mobile is-4-tablet spacing-between">
              <div className="community-stats-item greyout">
              <div className="actionwords">
                  <span>Project</span>
                </div>
                <div className="community-title greyout-phrase">
                Partnership/Sponsorship
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="has-text-centered">
          <button disabled className="button primary is-medium is-rounded">
            <span>Contact</span>
          </button>
        </div>
      </section>
    </>
  );
}
